module.exports = __webpack_public_path__ + "img/banner_AboutUs2_Mobile.28d424e2.png";